import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

import { roundDecimal } from '#root/utils';
import { GuveryPaper } from '#root/ui-components/cards';
import styles from './dealTable.module.scss';

const DealTable = (props) => {
  const { deal = {} } = props;
  const comBruta = deal?.comtot ? Number(deal.comtot) : 0;
  const matchFee = deal?.guvery_match_fee ? Number(deal.guvery_match_fee) : 0;
  const hasMatchFee = matchFee > 0;
  const comNeta = comBruta - matchFee;

  return (
    <GuveryPaper disableHover disableElevation className={styles.card}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <span className={styles.headerTitle}>Detalle del acuerdo</span>
        </div>
      </div>
      <hr className={styles.divider} />
      <div className={styles.body}>
        <Table className={styles.table}>
          <TableHead className={styles.headerTable}>
            <TableRow>
              <TableCell>Producto</TableCell>
              <TableCell className="guv-ellipsis">Precio Real</TableCell>
              <TableCell>Comisión</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={styles.bodyTable}>
            {deal?.deal_orders?.map((order, index) => {
              const orderCom = hasMatchFee && comBruta > 0
                ? order.com - (matchFee * order.com / comBruta)
                : order.com;
              return (
                <TableRow key={index}>
                  <TableCell>
                    <span className={styles.name}>
                      <span>{`${order.can} x`}</span>
                      <a
                        className={styles.link}
                        href={order.url}
                        target="_blank"
                        rel="noopener noreferrer">
                        <span>{order.fixed_url}</span>
                      </a>
                    </span>
                  </TableCell>
                  <TableCell>$ {roundDecimal(order.pre)}</TableCell>
                  <TableCell>$ {roundDecimal(orderCom)}</TableCell>
                  <TableCell>$ {roundDecimal(order.pre + orderCom)}</TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <span className={styles.total}>Total</span>
              </TableCell>
              <TableCell>
                <span className={styles.total}>$ {roundDecimal(deal.total_traveler)}</span>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {hasMatchFee && (
          <div className={styles.breakdown}>
            <span className={styles.breakdownNote}>
              Match Fee ya descontado. Comisión neta: <strong>$ {roundDecimal(comNeta)}</strong>.
            </span>
          </div>
        )}
      </div>
    </GuveryPaper>
  );
};

export default DealTable;
